module.exports = __webpack_public_path__ + "img/indu_active_4.594dcefd.png";